<form [formGroup]="datiGeneraliForm" (ngSubmit)="save();">
  <app-dati-generali-fascicolo-common [request]="request" [fascicolo]="fascicolo" [inserimento]="inserimento" [datiGeneraliForm]="datiGeneraliForm" (changedFondoRischiState)="changedFondoRischiState()"></app-dati-generali-fascicolo-common>                                                                        
  <app-protocol-fascicolo-form [fascicolo]="fascicolo" (protocolDataChange)="onDataProtocol($event)" [dataView]="protocollo" /> 
  <ng-template [ngIf]="!inserimento">
    <div class="row">
      <div checkBoxRadio class="col-sm-4" [labelInput]="'Deliberato'" idInput="deliberato"
        formControlName="flagDeliberato" [objectReference]="request.fascicolo.esitoDefinitivo" [submitPending]="true">
      </div>

      <div textInput [control]="datiGeneraliForm.controls['ndelibera']" class="col-sm-4"
        [labelInput]="'N&deg; delibera'" formControlName="nDelibera" [submitPending]="true"
        [(ngModel)]="request.fascicolo.numeroDelibera"></div>

      <div datePickerInput class="col-sm-4" [labelInput]="'Data delibera'" formControlName="dataDelibera"
        [dataAl]="request.fascicolo.dataDelibera" [submitPending]="true"
        [control]="datiGeneraliForm.controls['dataDelibera']" [(ngModel)]="request.fascicolo.dataDelibera"
        [mandatory]="false"></div>

    </div>
  </ng-template>


  <div class="row">
    <div comboModInput class="col-sm-3" [labelInput]="'Oggetto ricorso'"
         [control]="datiGeneraliForm.controls['oggettoRicorso']"
         formControlName="oggettoRicorso" [labelOption]="'label'"
         [ngModel]="request.fascicolo.oggettoRicorso"
         [objectReference]="request.fascicolo.oggettoRicorso"
         (onReturn)="request.fascicolo.oggettoRicorso = $event"
         [optionsCombo] ="oggettiRicorsoOptions" [mandatory]="true">
    </div>

    <div textInput [control]="datiGeneraliForm.controls['numeroProvvedimento']" class="col-sm-3"
      [labelInput]="'N&deg; provvedimento impugnato'" formControlName="numeroProvvedimento"
      [(ngModel)]="request.fascicolo.numeroProvvedimento"></div>

    <div datePickerInput class="col-sm-3" [labelInput]="'Data provvedimento impugnato'" formControlName="dataProvvedimento"
      [control]="datiGeneraliForm.controls['dataProvvedimento']" [(ngModel)]="request.fascicolo.dataProvvedimento"
      [mandatory]="false"></div>

    <div comboModInput class="col-sm-3" [labelInput]="'Organo'"
      [control]="datiGeneraliForm.controls['organoCompetente']"
      formControlName="organoCompetente" [labelOption]="'label'"
      [ngModel]="request.fascicolo.organoCompetente"
      [objectReference]="request.fascicolo.organoCompetente"
      (onReturn)="request.fascicolo.organoCompetente = $event;"
      [optionsCombo] ="organiCompetentiOptions">
    </div>

  </div>

  <!--<div class="row">
    <div textInput [control]="datiGeneraliForm.controls['numeroGiuntaEsecutiva']" class="col-sm-6"
      [labelInput]="'N&deg; Giunta Esecutiva'" formControlName="numeroGiuntaEsecutiva"
      [(ngModel)]="request.fascicolo.numeroGiuntaEsecutiva" [submitPending]="(request.fascicolo.organoCompetente && request.fascicolo.organoCompetente.label != 'GIUNTA ESECUTIVA') || !request.fascicolo.organoCompetente "></div>

    <div datePickerInput class="col-sm-6" [labelInput]="'Data Giunta Esecutiva'" formControlName="dataGiuntaEsecutiva"
      [dataAl]="request.fascicolo.dataGiuntaEsecutiva" [control]="datiGeneraliForm.controls['dataGiuntaEsecutiva']"
      [(ngModel)]="request.fascicolo.dataGiuntaEsecutiva" [submitPending]="(request.fascicolo.organoCompetente && request.fascicolo.organoCompetente.label != 'GIUNTA ESECUTIVA') || !request.fascicolo.organoCompetente " [mandatory]="false"></div>
  </div>-->

  <!--<div class="row">
    <div checkBoxRadio class="col-sm-6"
         [labelInput]="'Integrato'" idInput="integrato"
         formControlName="flagIntegrato" [objectReference]="request.fascicolo.integrato"
         [submitPending]= "true"
         (onReturn)=" request.fascicolo.integrato = $event;"></div>
    <div datePickerInput class="col-sm-6" [labelInput]="'Data integrazione'"
         formControlName="dataIntegrazione" [dataAl]="request.fascicolo.dataIntegrazione"
         [control]="datiGeneraliForm.controls['dataIntegrazione']"
         [submitPending]= "true"
         [(ngModel)]="request.fascicolo.dataIntegrazione"
         [mandatory]="false"></div>
  </div>-->



  <div class="row">
    <div textAreaInput class="form-group col-xs-12 col-sm-12" [labelInput]="'Note'" formControlName="note"
      [(ngModel)]="request.fascicolo.note"></div>
  </div>

  <div>
    <h3 class="title1level">Campi personalizzati</h3>
        <app-fascicolo-metadata-form *ngIf="!fascicolo.id && fascicolo.tipoFascicolo.id"
          [tipoFascicolo]="fascicolo.tipoFascicolo.id"
          (metadataListChange)="onRetrieve($event)"
          (formChange)="isFormMetadataValid($event)">
        </app-fascicolo-metadata-form>
        <app-fascicolo-metadata-form *ngIf="fascicolo.id && fascicolo.tipoFascicolo.id"
          [fascicolo]="request.fascicolo"
          (metadataListChange)="onRetrieve($event)"
          (formChange)="isFormMetadataValid($event)">
        </app-fascicolo-metadata-form>
  </div>

  <div class="row">
    <p class="mandatory col-sm-12">
      <em>* Campi obbligatori</em>
    </p>
  </div>
  <div *ngIf="checkFondoRischiRemoved && !request.fascicolo.flagFondoRischi" class="row">
    <div class="col-sm-12 form-group">
      <p *ngIf="checkFondoRischiRemoved" confermaCambioFr #confermaCambioFrModifica (onReturn)="notifyConferma($event)">
      </p>
    </div>
  </div>

  <div [ngClass]="minervaWizard ? 'wizard-buttons' : ''" class="row">
    <p class="col-sm-3 col-xs-6">
      <button type="button" class="btn btn-outline-secondary btn-block" (click)="resetForm.emit()">Reset</button>
    </p>
    <p submitButton class="col-sm-3 col-xs-6 col-sm-offset-6" [labelButton]="minervaWizard ? 'Prosegui' : 'Salva'" [disabled]=" (checkFondoRischiRemoved && !request.fascicolo.flagFondoRischi ? !confermaFrChangeChecked : false) ||
														( (changeFondoRischi && !request.fascicolo.dataVariazioneFondoRischi) && ( !inserimento ) && ( !wizard ) ) ||
														!datiGeneraliForm.valid || !metadataFormValid"></p>
  </div>
</form>
